// FIXME (gio): copy here all static assets and/or webpack externals for now

import 'theme';
import 'react-flexview/lib/flexView.css';




// WEBPACK FOOTER //
// ./src/app/assets.js